export const ACTIONS = {
  RECORD_QUESTION_ATTEMPT: 'RECORD_QUESTION_ATTEMPT',
  RECORD_STUDENT_ACTIVITY: 'RECORD_STUDENT_ACTIVITY',
  RESOLVE_STUDENT_ALERTS: 'RESOLVE_STUDENT_ALERTS',
};

export const recordStudentActivity = data => dispatch => {
  dispatch({
    type: ACTIONS.RECORD_STUDENT_ACTIVITY,
    payload: data,
  });
};

export const resolveStudentAlerts = data => dispatch => {
  dispatch({
    type: ACTIONS.RESOLVE_STUDENT_ALERTS,
    payload: data,
  });
};
